import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

const neumorphicInputStyles =
    'font-(family-name:--primary-font) text-[0.925rem] font-medium tracking-[-0.01em] ' +
    'text-(--input-neumorphic-text)! w-full min-w-0 text-ellipsis focus:text-clip px-5.5! py-3.5! ' +
    'border-[0.063rem] border-solid border-(--control-border-neumorphic) rounded-full ' +
    'bg-(image:--control-bg-neumorphic)! outline-none scheme-light transition-[border-color,box-shadow] ' +
    'duration-150 ease-out motion-reduce:transition-none shadow-(--input-neumorphic-base-shadow)! ' +
    'placeholder:text-(--text-muted)! placeholder:font-normal placeholder:tracking-[0.01em] ' +
    'hover:not-focus:not-disabled:border-(--control-border-neumorphic-hover) ' +
    'hover:not-focus:not-disabled:bg-(image:--control-bg-neumorphic-hover)! ' +
    'focus:border-(--input-neumorphic-focus-border) focus:ring-2 focus:ring-(--slate-alpha-12) ' +
    'enabled:aria-invalid:border-(--input-neumorphic-error-border)! enabled:aria-invalid:ring ' +
    'enabled:aria-invalid:ring-(--danger-soft-alpha-12) ' +
    'enabled:aria-invalid:focus:border-(--input-neumorphic-error-border-focus)! ' +
    'enabled:aria-invalid:focus:ring-2 enabled:aria-invalid:focus:ring-(--danger-soft-alpha-12) ' +
    '[&:-webkit-autofill]:[-webkit-text-fill-color:var(--input-neumorphic-text)] ' +
    '[&:-webkit-autofill]:caret-(--input-neumorphic-text) disabled:cursor-not-allowed disabled:transition-none ' +
    'disabled:opacity-[0.55] disabled:text-(--text-muted)! disabled:bg-(image:--input-neumorphic-disabled-bg)! ' +
    'disabled:border-(--input-neumorphic-disabled-border)! ' +
    'disabled:shadow-(--input-neumorphic-disabled-shadow)!';

export default {
    variants: {
        variant: {
            datePicker: {
                root: 'outline-none! ring-0! focus-within:outline-none! focus-within:ring-0!',
                base:
                    'outline-none! ring-0! border-(--control-border-neumorphic)! bg-(--input-bg)! ' +
                    'bg-(image:--control-bg-neumorphic)! text-(--input-neumorphic-text)! ' +
                    'shadow-(--panel-shadow-soft-inset)! placeholder:text-(--text-muted)! ' +
                    'hover:border-(--control-border-neumorphic-hover)! ' +
                    'hover:bg-(image:--control-bg-neumorphic-hover)! hover:shadow-(--input-neumorphic-hover-shadow)! ' +
                    'focus:outline-none! focus:ring-0! focus:border-(--input-neumorphic-focus-border)! ' +
                    'focus-visible:outline-none! focus-visible:ring-0! ' +
                    'focus-visible:border-(--input-neumorphic-focus-border)! ' +
                    'focus:bg-(image:--control-bg-neumorphic)! focus:text-(--input-neumorphic-text)! ' +
                    'focus:shadow-(--input-neumorphic-focus-shadow)!',
                trailing: 'pe-1'
            },
            frozenGlass:
                'font-(family-name:--primary-font) bg-(--input-frozen-bg) ' +
                '[backdrop-filter:blur(0.625rem)_saturate(1.2)] border-[0.063rem] border-solid ' +
                'border-(--input-frozen-border) font-medium text-white rounded-(--border-radius-md) p-5! ' +
                '[transition:border-color_var(--transition-smooth),box-shadow_var(--transition-smooth),background-color_var(--transition-smooth)] ' +
                'will-change-[border-color,box-shadow,background-color] shadow-(--input-frozen-shadow) ' +
                'focus:outline-none focus:text-white focus:bg-(--input-frozen-focus-bg) ' +
                'focus:border-(--border-glass-subtle) focus:shadow-(--input-frozen-focus-shadow) ' +
                'placeholder:text-(--white-alpha-30) placeholder:font-(family-name:--secondary-font) ' +
                'placeholder:uppercase placeholder:text-[0.75rem] placeholder:font-bold',
            neumorphic: neumorphicInputStyles,
            markup: `${neumorphicInputStyles} max-w-[9.6rem]! px-4! py-3!`,
            compact:
                'font-(family-name:--primary-font) text-[0.75rem] font-semibold text-(--text-dark) w-full min-w-0 ' +
                'px-[0.45rem]! py-[0.32rem]! border-[0.094rem] border-solid border-(--slate-alpha-18) ' +
                'rounded-[0.4rem] bg-(--glass-surface-bg-40) shadow-(--input-compact-shadow) outline-none ' +
                '[transition:border-color_0.2s_ease,box-shadow_0.2s_ease] placeholder:text-(--text-muted) ' +
                'placeholder:font-normal hover:not-focus:not-disabled:border-(--slate-alpha-30) focus:outline-none ' +
                'focus:border-(--accent-solid) focus:shadow-(--progress-glow-focus-shadow) ' +
                'focus-visible:outline-none focus-visible:border-(--accent-solid) ' +
                'focus-visible:shadow-(--progress-glow-focus-shadow) disabled:cursor-not-allowed ' +
                'disabled:opacity-[0.55] disabled:text-(--text-muted)'
        }
    }
} satisfies NuxtUiTheme['input'];
